module.exports = __webpack_public_path__ + "img/tinteccnc_logo.489ffe4b.svg";